<template>
  <div id="app">
	<router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  components: {
	  
  },
  mounted(){
	  // 判断是pc端还是移动端进行页面跳转
	  // var fullPath=this.$route.fullPath;
	  // if (this._isMobile()) {
		 //  if(fullPath.indexOf("/mobile")==-1){
	  // console.log("/mobile"+fullPath)
			// this.$router.replace("/mobile"+fullPath);
		 //  }
	  // } else {
		 //  if(fullPath.indexOf("/mobile")!=-1){
			//   var reg = new RegExp("/mobile"); // 不加'g'，仅删除字符串里第一个"a"
			//   fullPath = fullPath.replace(reg,"");
			// this.$router.replace(fullPath);
		 //  }
	  // }
  },
  methods: {
	_isMobile() {
		let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
		return flag;
	},
	reload() {
		location.reload()
	},
  },
}
</script>

<style>
</style>
